import { SystemEventTypeEnum, TUseAppHook, TUseDetectDocumentScroll } from '@libs/types';
import { eventBus, getLocale } from '@libs/utils';
import { Dispatch, SetStateAction, useEffect, useState, useSyncExternalStore } from 'react';
import { createRequiredContext } from './contextService';

type TContext = Dispatch<SetStateAction<React.ReactNode>>;
export const [usePortal, PortalProvider] = createRequiredContext<{
    setModal: TContext;
    setPopup: TContext;
    setBottomSheet: Dispatch<SetStateAction<string | undefined>>;
    setModalWindow: Dispatch<SetStateAction<string | undefined>>;
}>();

export const useDetectDocumentScroll = (uid: string): TUseDetectDocumentScroll => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        eventBus.subscribe(SystemEventTypeEnum.SCROLLED, uid, (value) => setScrolled(!!value));
        return () => eventBus.unsubscribe(SystemEventTypeEnum.SCROLLED, uid);
    }, [uid]);
    return { documentScrolled: scrolled };
};
export const useApp = (): TUseAppHook => {
    const { setModal, setPopup, setBottomSheet, setModalWindow } = usePortal();
    return { setModal, setPopup, setBottomSheet, setModalWindow, language: getLocale() };
};
export const useOnline = () => {
    return useSyncExternalStore(subscribe, getSnapshot);
};

function getSnapshot() {
    return navigator?.onLine ?? true;
}

function subscribe(callback: () => void) {
    window.addEventListener('online', callback);
    window.addEventListener('offline', callback);
    return () => {
        window.removeEventListener('online', callback);
        window.removeEventListener('offline', callback);
    };
}
